import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useEstablishmentLocationChartsDataContext } from './hooks/useEstablishmentLocationChartsDataContext';

export const ManagementByYear = () => {
    const { chartData } = useEstablishmentLocationChartsDataContext();

    const data = chartData?.managementByYear || {};

    const categories = Object.keys(data).sort((a, b) => Number(a) - Number(b));

    const series = [
        {
            name: 'Estadual',
            data: categories.map((year) => data[year]?.E ?? 0)
        },
        {
            name: 'Municipal',
            data: categories.map((year) => data[year]?.M ?? 0)
        }
    ];

    return (
        <SimpleBars
            title="Gestão por Ano"
            horizontal={false}
            stacked
            subtitles={categories}
            series={series}
            showDataLabels={false}
            maxHeight="600px"
        />
    );
};